export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  description: string;
  coverImage: string;
  categories: string[];
  status: '连载中' | '已完结' | '停更';
  rating: number;
  views: number;
  likes: number;
  updatedAt: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const categories: ComicCategory[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 1280 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 960 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 850 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 720 },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', count: 640 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 890 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 340 },
  { slug: 'school', name: '校园', icon: 'ri-building-line', count: 560 },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'secret-garden',
    title: '秘密花园',
    author: '金智恩',
    description: '一个关于爱情与成长的动人故事。女主角林素恩在首尔繁华都市中遇见了改变她一生的那个人，在秘密花园般的相遇中，两人共同经历了欢笑与泪水，最终找到了属于彼此的幸福。画风细腻柔美，情节温暖治愈，是近年来最受欢迎的韩漫作品之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20with%20beautiful%20couple%20in%20flower%20garden%2C%20soft%20pastel%20colors%2C%20watercolor%20style%2C%20dreamy%20atmosphere%2C%20gentle%20lighting%2C%20cherry%20blossom%20petals%20floating%2C%20elegant%20composition%2C%20clean%20background%20with%20subtle%20floral%20elements%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-01&orientation=portrait',
    categories: ['romance', 'drama'],
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    likes: 89000,
    updatedAt: '2026-07-03',
    chapters: [
      { id: 'ch1-1', title: '命运的相遇', number: 1, updatedAt: '2026-01-15' },
      { id: 'ch1-2', title: '雨中的约定', number: 2, updatedAt: '2026-01-22' },
      { id: 'ch1-3', title: '心跳加速', number: 3, updatedAt: '2026-01-29' },
      { id: 'ch1-4', title: '意外的告白', number: 4, updatedAt: '2026-02-05' },
      { id: 'ch1-5', title: '甜蜜的日常', number: 5, updatedAt: '2026-02-12' },
      { id: 'ch1-6', title: '考验来临', number: 6, updatedAt: '2026-02-19' },
      { id: 'ch1-7', title: '真心话', number: 7, updatedAt: '2026-02-26' },
      { id: 'ch1-8', title: '选择', number: 8, updatedAt: '2026-03-05' },
      { id: 'ch1-9', title: '勇气', number: 9, updatedAt: '2026-03-12' },
      { id: 'ch1-10', title: '重逢', number: 10, updatedAt: '2026-03-19' },
      { id: 'ch1-11', title: '新的开始', number: 11, updatedAt: '2026-03-26' },
      { id: 'ch1-12', title: '幸福绽放', number: 12, updatedAt: '2026-04-02' },
    ],
    tags: ['纯爱', '治愈', '都市'],
  },
  {
    id: '2',
    slug: 'blade-of-destiny',
    title: '命运之刃',
    author: '朴志浩',
    description: '在剑与魔法的世界中，少年剑士韩宇辰踏上复仇之路。沉浸在黑暗过去中成长的少年，手握传说中的命运之刃，踏上充满艰险的冒险之旅。华丽的战斗场面、复杂的角色关系、出人意料的剧情转折，这部奇幻动作韩漫绝对让你欲罢不能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20cover%2C%20warrior%20holding%20glowing%20sword%20in%20dark%20fantasy%20world%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20cool%20color%20tones%2C%20detailed%20armor%2C%20magical%20energy%20effects%2C%20clean%20dark%20background%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-02&orientation=portrait',
    categories: ['action', 'fantasy'],
    status: '连载中',
    rating: 4.9,
    views: 2100000,
    likes: 156000,
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch2-1', title: '觉醒之日', number: 1, updatedAt: '2026-01-10' },
      { id: 'ch2-2', title: '剑术修行', number: 2, updatedAt: '2026-01-17' },
      { id: 'ch2-3', title: '初战', number: 3, updatedAt: '2026-01-24' },
      { id: 'ch2-4', title: '神秘导师', number: 4, updatedAt: '2026-01-31' },
      { id: 'ch2-5', title: '黑暗森林', number: 5, updatedAt: '2026-02-07' },
      { id: 'ch2-6', title: '宿敌登场', number: 6, updatedAt: '2026-02-14' },
      { id: 'ch2-7', title: '决斗', number: 7, updatedAt: '2026-02-21' },
      { id: 'ch2-8', title: '真相', number: 8, updatedAt: '2026-02-28' },
      { id: 'ch2-9', title: '新的征程', number: 9, updatedAt: '2026-03-07' },
      { id: 'ch2-10', title: '龙之谷', number: 10, updatedAt: '2026-03-14' },
      { id: 'ch2-11', title: '传承之力', number: 11, updatedAt: '2026-03-21' },
      { id: 'ch2-12', title: '命运齿轮', number: 12, updatedAt: '2026-03-28' },
      { id: 'ch2-13', title: '终焉序曲', number: 13, updatedAt: '2026-04-04' },
      { id: 'ch2-14', title: '光与暗', number: 14, updatedAt: '2026-04-11' },
    ],
    tags: ['热血', '冒险', '魔法'],
  },
  {
    id: '3',
    slug: 'night-detective',
    title: '深夜侦探',
    author: '李秀贤',
    description: '首尔深夜的街头，连环案件频发。退役刑警姜道贤成为私家侦探，接手一个个离奇案件。每一条线索背后都隐藏着不为人知的秘密，每一次推理都扣人心弦。心理悬疑与犯罪推理的完美结合，让你跟随主角一步步揭开真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20Seoul%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20dark%20moody%20tones%2C%20cinematic%20composition%2C%20clean%20background%20with%20urban%20elements%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-03&orientation=portrait',
    categories: ['thriller', 'drama'],
    status: '连载中',
    rating: 4.7,
    views: 980000,
    likes: 72000,
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch3-1', title: '深夜来电', number: 1, updatedAt: '2026-02-01' },
      { id: 'ch3-2', title: '第一个委托人', number: 2, updatedAt: '2026-02-08' },
      { id: 'ch3-3', title: '消失的线索', number: 3, updatedAt: '2026-02-15' },
      { id: 'ch3-4', title: '目击者', number: 4, updatedAt: '2026-02-22' },
      { id: 'ch3-5', title: '红色高跟鞋', number: 5, updatedAt: '2026-03-01' },
      { id: 'ch3-6', title: '谎言', number: 6, updatedAt: '2026-03-08' },
      { id: 'ch3-7', title: '追捕', number: 7, updatedAt: '2026-03-15' },
      { id: 'ch3-8', title: '审讯', number: 8, updatedAt: '2026-03-22' },
      { id: 'ch3-9', title: '真相浮现', number: 9, updatedAt: '2026-03-29' },
      { id: 'ch3-10', title: '最终对决', number: 10, updatedAt: '2026-04-05' },
    ],
    tags: ['推理', '犯罪', '都市'],
  },
  {
    id: '4',
    slug: 'campus-love-story',
    title: '校园恋歌',
    author: '崔美英',
    description: '高中校园里的青春恋曲。阳光开朗的转学生与冰山学霸的意外交集，从最初的针锋相对到渐渐心动的甜蜜日常。青涩可爱的画风、真实细腻的情感描写，带你回到那段最美好的青春时光。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%2C%20two%20high%20school%20students%20in%20uniform%20under%20cherry%20blossom%20tree%2C%20spring%20sunlight%2C%20soft%20warm%20colors%2C%20youthful%20atmosphere%2C%20gentle%20breeze%20effect%2C%20clean%20pastel%20background%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-04&orientation=portrait',
    categories: ['romance', 'school', 'comedy'],
    status: '已完结',
    rating: 4.6,
    views: 1860000,
    likes: 134000,
    updatedAt: '2026-06-15',
    chapters: [
      { id: 'ch4-1', title: '转学生', number: 1, updatedAt: '2025-09-01' },
      { id: 'ch4-2', title: '同桌的你', number: 2, updatedAt: '2025-09-08' },
      { id: 'ch4-3', title: '图书馆偶遇', number: 3, updatedAt: '2025-09-15' },
      { id: 'ch4-4', title: '雨天', number: 4, updatedAt: '2025-09-22' },
      { id: 'ch4-5', title: '运动会', number: 5, updatedAt: '2025-09-29' },
      { id: 'ch4-6', title: '文化节', number: 6, updatedAt: '2025-10-06' },
      { id: 'ch4-7', title: '误会', number: 7, updatedAt: '2025-10-13' },
      { id: 'ch4-8', title: '和好', number: 8, updatedAt: '2025-10-20' },
      { id: 'ch4-9', title: '告白', number: 9, updatedAt: '2025-10-27' },
      { id: 'ch4-10', title: '毕业季', number: 10, updatedAt: '2025-11-03' },
    ],
    tags: ['青春', '校园', '纯爱'],
  },
  {
    id: '5',
    slug: 'ghost-apartment',
    title: '幽灵公寓',
    author: '郑允浩',
    description: '搬入廉价公寓的大学生意外发现，这栋公寓的住户们似乎都不是普通人。每到午夜时分，公寓里就会发生不可思议的事情。恐怖与温情交织的超自然故事，让你在恐惧中感受人性的温暖。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20supernatural%20cover%2C%20old%20apartment%20building%20with%20mysterious%20glowing%20windows%20at%20midnight%2C%20foggy%20atmosphere%2C%20eerie%20mood%2C%20dark%20blue%20and%20purple%20tones%2C%20spooky%20yet%20beautiful%20composition%2C%20clean%20dark%20background%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-05&orientation=portrait',
    categories: ['horror', 'thriller'],
    status: '连载中',
    rating: 4.5,
    views: 760000,
    likes: 58000,
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch5-1', title: '新居', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch5-2', title: '奇怪的邻居', number: 2, updatedAt: '2026-03-08' },
      { id: 'ch5-3', title: '午夜钟声', number: 3, updatedAt: '2026-03-15' },
      { id: 'ch5-4', title: '401室的秘密', number: 4, updatedAt: '2026-03-22' },
      { id: 'ch5-5', title: '照片上的影子', number: 5, updatedAt: '2026-03-29' },
      { id: 'ch5-6', title: '管理员', number: 6, updatedAt: '2026-04-05' },
      { id: 'ch5-7', title: '地下室', number: 7, updatedAt: '2026-04-12' },
      { id: 'ch5-8', title: '往生', number: 8, updatedAt: '2026-04-19' },
    ],
    tags: ['恐怖', '灵异', '悬疑'],
  },
  {
    id: '6',
    slug: 'daily-comedy-king',
    title: '搞笑日常王',
    author: '安在旭',
    description: '平凡上班族的爆笑日常！职场菜鸟金民秀的各种乌龙事件，从面试出糗到办公室搞笑日常，每一话都能让你捧腹大笑。轻松减压的喜剧韩漫，治愈你一天的疲惫。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20cover%2C%20funny%20office%20worker%20with%20exaggerated%20expression%2C%20bright%20colorful%20cartoon%20style%2C%20humorous%20vibrant%20atmosphere%2C%20clean%20white%20background%20with%20pop%20art%20elements%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-06&orientation=portrait',
    categories: ['comedy', 'drama'],
    status: '连载中',
    rating: 4.4,
    views: 1540000,
    likes: 112000,
    updatedAt: '2026-07-03',
    chapters: [
      { id: 'ch6-1', title: '面试大作战', number: 1, updatedAt: '2026-01-05' },
      { id: 'ch6-2', title: '第一天上班', number: 2, updatedAt: '2026-01-12' },
      { id: 'ch6-3', title: '午餐风云', number: 3, updatedAt: '2026-01-19' },
      { id: 'ch6-4', title: '加班夜', number: 4, updatedAt: '2026-01-26' },
      { id: 'ch6-5', title: '团建灾难', number: 5, updatedAt: '2026-02-02' },
      { id: 'ch6-6', title: '升职竞争', number: 6, updatedAt: '2026-02-09' },
      { id: 'ch6-7', title: '年会才艺', number: 7, updatedAt: '2026-02-16' },
      { id: 'ch6-8', title: '休假计划', number: 8, updatedAt: '2026-02-23' },
      { id: 'ch6-9', title: '离职风波', number: 9, updatedAt: '2026-03-02' },
      { id: 'ch6-10', title: '新的开始', number: 10, updatedAt: '2026-03-09' },
    ],
    tags: ['搞笑', '日常', '职场'],
  },
  {
    id: '7',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '韩素希',
    description: '平凡少年意外收到魔法学院的录取通知书，从此开启了一段不可思议的魔法之旅。在这里他结识了性格各异的伙伴们，共同学习魔法、对抗黑暗势力。华丽的魔法特效与精彩的冒险剧情，这部奇幻校园韩漫不容错过。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20magic%20school%20cover%2C%20students%20in%20robes%20casting%20colorful%20spells%20at%20grand%20magical%20academy%2C%20floating%20crystals%2C%20warm%20golden%20lighting%2C%20enchanting%20atmosphere%2C%20detailed%20architecture%2C%20clean%20background%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-07&orientation=portrait',
    categories: ['fantasy', 'school', 'action'],
    status: '连载中',
    rating: 4.7,
    views: 1320000,
    likes: 98000,
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch7-1', title: '神秘来信', number: 1, updatedAt: '2026-02-10' },
      { id: 'ch7-2', title: '踏入学院', number: 2, updatedAt: '2026-02-17' },
      { id: 'ch7-3', title: '第一堂课', number: 3, updatedAt: '2026-02-24' },
      { id: 'ch7-4', title: '魔法对决', number: 4, updatedAt: '2026-03-03' },
      { id: 'ch7-5', title: '禁林探险', number: 5, updatedAt: '2026-03-10' },
      { id: 'ch7-6', title: '友谊试炼', number: 6, updatedAt: '2026-03-17' },
      { id: 'ch7-7', title: '黑暗降临', number: 7, updatedAt: '2026-03-24' },
      { id: 'ch7-8', title: '守护学院', number: 8, updatedAt: '2026-03-31' },
      { id: 'ch7-9', title: '传说之书', number: 9, updatedAt: '2026-04-07' },
      { id: 'ch7-10', title: '最终考试', number: 10, updatedAt: '2026-04-14' },
    ],
    tags: ['魔法', '校园', '冒险'],
  },
  {
    id: '8',
    slug: 'tears-of-autumn',
    title: '秋之泪',
    author: '尹秀晶',
    description: '一段跨越十年的深情守候。两个从小一起长大的青梅竹马，因为命运的捉弄而分离，又在秋叶飘落的季节重逢。成年后的他们能否克服重重阻碍，重新找回那份纯真的爱恋？催泪治愈的情感大作，纸巾请备好。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20romance%20cover%2C%20couple%20walking%20on%20autumn%20street%20with%20falling%20maple%20leaves%2C%20warm%20amber%20and%20golden%20tones%2C%20melancholic%20yet%20beautiful%20atmosphere%2C%20soft%20backlight%2C%20emotional%20composition%2C%20clean%20background%2C%20vertical%20portrait%20format&width=600&height=860&seq=comic-cover-08&orientation=portrait',
    categories: ['drama', 'romance'],
    status: '已完结',
    rating: 4.9,
    views: 1980000,
    likes: 167000,
    updatedAt: '2026-05-20',
    chapters: [
      { id: 'ch8-1', title: '童年', number: 1, updatedAt: '2025-11-01' },
      { id: 'ch8-2', title: '离别', number: 2, updatedAt: '2025-11-08' },
      { id: 'ch8-3', title: '各自成长', number: 3, updatedAt: '2025-11-15' },
      { id: 'ch8-4', title: '大学时光', number: 4, updatedAt: '2025-11-22' },
      { id: 'ch8-5', title: '命运重逢', number: 5, updatedAt: '2025-11-29' },
      { id: 'ch8-6', title: '旧日回忆', number: 6, updatedAt: '2025-12-06' },
      { id: 'ch8-7', title: '误会', number: 7, updatedAt: '2025-12-13' },
      { id: 'ch8-8', title: '坦白', number: 8, updatedAt: '2025-12-20' },
      { id: 'ch8-9', title: '选择', number: 9, updatedAt: '2025-12-27' },
      { id: 'ch8-10', title: '秋之泪', number: 10, updatedAt: '2026-01-03' },
      { id: 'ch8-11', title: '终章·幸福', number: 11, updatedAt: '2026-01-10' },
    ],
    tags: ['催泪', '纯爱', '成长'],
  },
];

export const siteStats = {
  totalComics: 12580,
  totalChapters: 356000,
  activeReaders: 2800000,
  dailyUpdates: 86,
};

export const aboutInfo = {
  brandName: '韩漫之家',
  foundedYear: '2018',
  introduction: '韩漫之家成立于2018年，是国内领先的韩漫在线阅读平台。我们致力于为广大韩漫爱好者提供优质的阅读体验，采用智能加载技术，实现流畅舒适的下拉式阅读。平台汇聚海量精品韩漫资源，涵盖恋爱、奇幻、动作、悬疑、喜剧、剧情等多种类型，满足不同读者的需求。',
  mission: '让每一位韩漫爱好者都能轻松、便捷地享受优质的漫画阅读体验。',
  vision: '成为华语地区最具影响力的韩漫阅读平台，推动韩漫文化在中国的传播与发展。',
  values: [
    { title: '品质至上', description: '精心筛选每一部作品，确保内容质量与阅读体验' },
    { title: '用户体验', description: '持续优化平台功能，打造最舒适的下拉式阅读环境' },
    { title: '正版支持', description: '尊重原创作者权益，致力于推动正版韩漫内容传播' },
    { title: '社区共建', description: '打造活跃的读者社区，让韩漫爱好者交流分享' },
  ],
  testimonials: [
    { name: '小明', role: '忠实读者', content: '韩漫之家的下拉式阅读真的太舒服了！智能加载很快，再也不用等半天才能看到下一页了。漫画资源也很全，想看的韩漫基本都能找到。' },
    { name: '漫画迷小红', role: '资深韩漫爱好者', content: '从2019年就开始在韩漫之家看漫画了，界面越来越好看，阅读体验也越来越好。分类很细致，找漫画很方便。推荐给所有喜欢韩漫的朋友！' },
    { name: '阿杰', role: '漫画博主', content: '作为漫画博主，我试过很多漫画平台。韩漫之家的智能加载技术确实是业内领先的，下拉式阅读流畅度没话说。更新速度也很快，基本同步韩国那边的进度。' },
  ],
  contact: {
    email: 'hello@rfeff.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T3号楼 1806室',
    wechat: 'hanmanzhijia',
    weibo: '@韩漫之家官方',
  },
  faqs: [
    {
      question: '韩漫之家是什么？',
      answer: '韩漫之家是一个专注于韩漫在线阅读的专业平台，提供免费下拉式漫画阅读体验，采用智能加载技术确保阅读流畅舒适。平台汇聚大量精品韩漫资源，覆盖多种类型。',
    },
    {
      question: '如何使用下拉式阅读？',
      answer: '打开任意一部漫画后，页面会自动进入下拉式阅读模式。只需向下滚动页面，漫画内容就会自动加载，无需翻页点击。我们的智能预加载技术会在您阅读当前内容时提前加载后续内容，确保阅读过程无缝衔接。',
    },
    {
      question: '韩漫之家需要注册才能阅读吗？',
      answer: '不需要！韩漫之家目前完全免费开放，所有漫画均可直接在线阅读，无需注册登录。',
    },
    {
      question: '漫画多久更新一次？',
      answer: '我们会在韩国原版更新后第一时间同步更新，通常在24小时内完成。热门漫画的更新速度更快，部分作品可以实现实时同步。',
    },
    {
      question: '漫画内容是否有广告干扰？',
      answer: '我们严格控制广告数量和质量，确保广告不会影响您的阅读体验。漫画阅读页面的广告位置经过精心设计，不会遮挡漫画内容。',
    },
  ],
};